<template>
  <div>
    <div class="w-full px-6 h-20 flex justify-center items-center border-b relative">
      <h4 class="text-yank">Media Collection</h4>
      <div v-if="! $page.props.user" class="absolute right-0 inset-y-0 hidden lg:flex items-center mr-10">
        <AuthButtons />
      </div>
    </div>
    <div :style="`background-image: url('${collection.cover_url}')`"
         class="w-full p-8 lg:p-16 bg-cover bg-center bg-no-repeat relative">
      <div class="flex flex-col justify-center items-center text-white relative z-10">
        <h2 class="font-black text-5xl mb-4">{{ collection.name }}</h2>
        <span class="uppercase inline-block mb-6 tracking-2xl">{{ humanize(collection.type) }}</span>
        <a
          :href="$route('download', {type: 'collection', uuid: collection.uuid})"
          class="py-3 text-sm font-semibold text-center rounded-md bg-white text-black px-4 w-full md:w-4/12 xl:w-2/12"
        >
          Download All
        </a>
      </div>
      <div class="absolute inset-0 media-overlay z-0"></div>
    </div>
    <div class="px-10 py-20 grid grid-cols-1 gap-y-8">
      <section v-if="graphics.length">
        <h4 class="font-bold text-2xl mb-4">Graphics</h4>
        <div class="flex flex-wrap">
          <ItemComponent :item="item" v-for="item in graphics" :key="item.id"/>
        </div>
      </section>

      <section v-if="socialMedia.length">
        <h4 class="font-bold text-2xl mb-4">Social Media</h4>
        <div class="flex flex-wrap">
          <ItemComponent :item="item" v-for="item in socialMedia" :key="item.id"/>
        </div>
      </section>

      <section v-if="videos.length">
        <h4 class="font-bold text-2xl mb-4">Videos</h4>
        <div class="flex flex-wrap">
          <ItemComponent :item="item" v-for="item in videos" :key="item.id"/>
        </div>
      </section>

      <section v-if="photos.length">
        <h4 class="font-bold text-2xl mb-4">Photos</h4>
        <div class="flex flex-wrap">
          <ItemComponent :item="item" v-for="item in photos" :key="item.id"/>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import AppLayout from '@/layout/app-layout'
  import AuthButtons from "@/components/shared/AuthButtons"
  import ItemComponent from "@/components/home/ItemComponent"
  export default {
    name: 'Collection',

    layout: AppLayout,

    components: {ItemComponent, AuthButtons},

    props: {
      collection: Object,
    },

    metaInfo() {
      return {
        title: this.collection.name,
      }
    },

    data() {
      return {
        flickityOptions: {
          initialIndex: 1,
          prevNextButtons: false,
          pageDots: false,
          freeScroll: false,
          wrapAround: false,
          contain: true,
          cellAlign: 'left'
        }
      }
    },

    computed: {
      graphics() {
        if (! this.collection.items.length) {
          return []
        }

        return this.collection.items.filter(item => item.type == 'graphic')
      },

      socialMedia() {
        if (! this.collection.items.length) {
          return []
        }

        return this.collection.items.filter(item => item.type == 'social-media')
      },

      videos() {
        if (! this.collection.items.length) {
          return []
        }

        return this.collection.items.filter(item => item.type == 'video')
      },

      photos() {
        if (! this.collection.items.length) {
          return []
        }

        return this.collection.items.filter(item => item.type == 'photo')
      },
    },

    methods: {
      humanize(string) {
        return string.replaceAll('-', ' ')
      }
    }
  }
</script>

<style scoped>
.media-overlay{
  background: linear-gradient(180deg, #FFFFFF 0%, rgba(33,42,74,0.3) 100%);
}
</style>
